import { useLocation, Link } from 'react-router-dom';

export default function HeaderComponent() {
    const {pathname} = useLocation();

    const headerText = pathname === '/home' ? 'Contact' : 'Home';
    const leftHeaderText = pathname === '/home' ? 'Show sweep days for my ward and zone' : '';
    const target = pathname === '/home' ? '/contact' : '/home';
    const leftTarget = pathname === '/home' ? '/showsweeps' : '/home';

    return (
        
            <div className="header">
                <div className="headleft"> 
                    <Link to={leftTarget} style={{color: 'black'}}>{leftHeaderText}</Link>
                </div>
                <div className="headright">
                        <Link to={target} style={{color:'black'}}>{headerText}</Link>
                </div>      
            </div>

    )
}